/**
 * Created by Bart Decorte
 * Date: 24/06/2020
 * Time: 20:14
 */
import Page from '../Page';

export default class AppsAuthorize extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Apps/AppsAuthorize.js